<template>
    <router-link class="post-root" :to="getPositionURL" :class="{ promote: promote }">
        <div class="clickable px-2 py-2 d-flex flex-column align-items-center py-2 h-100">
            <div class="image-wrapper d-flex align-items-center">
                <img
                    v-if="image !== undefined"
                    class="image-default d-center image"
                    :src="image"
                    alt="title"
                />
            </div>

            <div class="mt-1 d-flex flex-column justify-content-between pb-3 flex-grow">
                <h5 class="subtitle bold text-center mb-2">
                    {{ title }}
                </h5>

                <div class="d-flex flex-column justify-content-end">
                    <span class="caption text-center mb-1">
                        <span class="mr-1">{{ companyName }}</span>
                        {{ position }}
                    </span>

                    <div
                        v-if="country || location"
                        class="d-flex align-items-center justify-content-center mb-2 gray-color"
                    >
                        <BaseIcon name="map-marker-alt" size="xs" />

                        <h6 class="caption text-small text-center m-0">
                            {{ location }}
                        </h6>
                    </div>

                    <h6 class="caption text-small text-center mb-1 gray-color">
                        {{ $t('shared.postingModule.postCard.deadline') }}:
                        {{ deadlineTime }}
                    </h6>
                </div>
            </div>

            <div class="d-flex flex-wrap justify-content-center">
                <div v-for="(item, index) in labels" :key="index">
                    <b-img
                        v-if="item.type === 'img'"
                        v-b-tooltip.hover
                        rounded
                        :src="item.img"
                        :alt="item.text"
                        :title="item.tooltip"
                        width="60"
                    />

                    <b-badge
                        v-else
                        v-b-tooltip.hover
                        pill
                        class="subtitle px-3 m-1"
                        :title="item.tooltip"
                        style="color: var(--secondary); border: 1px solid var(--secondary); background-color: white; display: block; white-space: nowrap;"
                    >
                        {{ item.text }}
                    </b-badge>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import dateToString from '~/utils/dateToString';

export default {
    name: 'PostingCard',
    props: {
        id: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        positionUrl: {
            type: String,
            default: '',
        },
        title: String,
        position: String,
        companyName: String,
        location: String,
        deadline: Number,
        country: String,
        RequestId: String,
        EventId: String,
        labels: Array,
        promote: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        deadlineTime: function() {
            this.$interfaces.localeModule.getLocaleItem(); // This is for updating deadline-string when locale changes
            return dateToString(this.$props.deadline);
        },
        getPositionURL: function() {
            if (this.positionUrl) {
                return this.positionUrl;
            } else {
                const url = this.$URLS.jobDetail.concat(
                    '/',
                    this.$props.id.toString(),
                    this.RequestId && this.EventId
                        ? `?RequestId=${this.RequestId}&EventId=${this.EventId}`
                        : ''
                );
                return url;
            }
        },
    },
};
</script>

<style scoped>
.post-root {
    background-color: white;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 200px;
    overflow: hidden;
    position: relative;
    display: inline-block;
    text-decoration: none;
}
.image {
    max-width: 100px;
}
.image-wrapper {
    width: 60%;
    overflow: hidden;
    height: 100px;
    max-height: 100px;
}

.text-small {
    font-size: 10px;
}

.promote::before {
    position: absolute;
    content: '';
    left: 10px;
    top: 10px;
    cursor: pointer;
    background-color: var(--secondary); /*Good yellow: #fde18c */
    mask-repeat: space;
    -webkit-mask-image: url('../../assets/img/star.svg');
    mask-image: url('../../assets/img/star.svg');

    opacity: 0.5;

    height: 10px;
    width: 10px;
}
</style>
